import React from 'react';
import axios from 'axios';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const DEFAULT_TITLE = 'About Harrison Ferlauto';
const DEFAULT_CONTENT = 'Thank you for visiting harrisonferlauto.com. My name is Harrison, and I am currently a Hand Surgery Fellow at the University of Colorado. I grew up in Long Island, New York and studied biomedical engineering as an undergraduate at Duke in North Carolina. I then completed my medical degree at the Duke University School of Medicine, and went on to complete residency training in orthopaedic surgery at the Icahn School of Medicine at Mount Sinai in New York City. My passions include hand surgery, orthopaedic surgery, jazz tenor saxophone, jazz piano, golf, and fishing. This website was designed to showcase some of my work and share some rather rare and valuable resources with the world.';
const DEFAULT_PHOTO = 'https://hrf-bucket.s3.amazonaws.com/1731037798465-Harrison%20Ferlauto%20Photo.jpg';

export default class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: DEFAULT_TITLE,
      content: DEFAULT_CONTENT,
      photoUrl: DEFAULT_PHOTO,
    };
    props.setActiveComponent('About');
  }

  async componentDidMount() {
    try {
      const res = await axios.get('/api/about');
      if (res.data) {
        this.setState({
          title: res.data.title !== undefined ? res.data.title : DEFAULT_TITLE,
          content: res.data.content !== undefined ? res.data.content : DEFAULT_CONTENT,
          photoUrl: (res.data.photo_url || res.data.photoUrl) !== undefined ? (res.data.photo_url || res.data.photoUrl) : DEFAULT_PHOTO,
        });
      }
    } catch (err) {
      console.error('Failed to fetch About content', err);
    }
  }

  render() {
    const { title, content, photoUrl } = this.state;
    return (
      <Card id="about" raised>
        <div className="about-title">{title}</div>
        <CardContent className="about-text">
          {content}
        </CardContent>

        {photoUrl && (
          <div className="photo-wrapper">
            <img src={photoUrl} className="harrison-photo" alt={title} />
          </div>
        )}
      </Card>
    );
  }
}

